<template>
	<div v-if="dataLoaded">
		<v-toolbar color="blue lighten-1" class="white--text">
			<v-icon color="white">monetization_on</v-icon>
			<v-toolbar-title>Kwoty projektu</v-toolbar-title>
		</v-toolbar>
		<div class="ma-4">
			<v-layout row align-center>
				<v-flex xs1/>
				<v-flex xs3>
					<v-subheader><strong>Kwota wnioskowana</strong></v-subheader>
				</v-flex>
				<v-flex xs6>
					<div v-if="!amounts.requestedDonation">brak</div>
					<div v-else>{{formatMoney(amounts.requestedDonation) + " PLN"}}</div>
				</v-flex>
			</v-layout>
			<v-layout row align-center>
				<v-flex xs1/>
				<v-flex xs3>
					<v-subheader><strong>Kwota przyznana</strong></v-subheader>
				</v-flex>
				<v-flex xs6>
					<div v-if="!amounts.summaryDonation">brak</div>
					<div v-else>{{formatMoney(amounts.summaryDonation) + " PLN"}}</div>
				</v-flex>
			</v-layout>
			<v-layout row align-center>
				<v-flex xs1/>
				<v-flex xs3>
					<v-subheader><strong>Kwota z umowy</strong></v-subheader>
				</v-flex>
				<v-flex xs6>
					<div v-if="!amounts.agreementDonation">brak</div>
					<div v-else>{{formatMoney(amounts.agreementDonation) + " PLN"}}</div>
				</v-flex>
			</v-layout>
			<v-layout row align-center>
				<v-flex xs1/>
				<v-flex xs3>
					<v-subheader><strong>Kwota zatwierdzona</strong></v-subheader>
				</v-flex>
				<v-flex xs6>
					<div v-if="!amounts.approvedDonation">brak</div>
					<div v-else>{{formatMoney(amounts.approvedDonation) + " PLN"}}</div>
				</v-flex>
			</v-layout>
			<v-layout row align-center>
				<v-flex xs1/>
				<v-flex xs3>
					<v-subheader><strong>Zatwierdzony wkład własny</strong></v-subheader>
				</v-flex>
				<v-flex xs6>
					<div v-if="!amounts.ownContribution">brak</div>
					<div v-else>{{formatMoney(amounts.ownContribution) + " PLN"}}</div>
				</v-flex>
			</v-layout>
		</div>
	</div>
</template>

<script>
	import {Project} from "../../../../api/generated/Project";
	import {Numbers} from "../../../../utils/Numbers";

	export default {
		name: "ProjectSummaryAmountsView",
		mixins: [Numbers],

		data () {
			return {
				amounts: {},
				dataLoaded: false
			};
		},

		created () {
			this.getProjectSummaryAmountsData();
		},

		methods: {
			getProjectSummaryAmountsData () {
				Project.getAmounts(this, this.$route.params.projectId, successResponse => {
						this.amounts = successResponse;
						this.dataLoaded = true;
					},
					errorResponse => {
						this.$messagesBus.$emit("error", "Nie udało się załadować kwot projektu", errorResponse);
					});
			}
		}
	};
</script>

<style scoped>

</style>